import { api_gateway } from '../../conexoes/api'
import { formatBusca } from '../../utils/genericFormatters'
import { requestResolver } from '../../utils/requestResolver'

const getParams = (busca, separadorLinha) => {
  if (!busca) return ''
  return formatBusca(busca, separadorLinha)
}

export const ESimsService = {
  //#region GET
  getESims: (
    pagina,
    linhasPorPagina,
    filtros = {},
    busca,
    separadorLinhaBusca,
    contagem
  ) => {
    const params = {
      params: {
        page: pagina,
        pageRows: linhasPorPagina,
        count: contagem,
        filter: filtros.vazio ? undefined : filtros,
        fetch: busca ? getParams(busca, separadorLinhaBusca) : undefined
      }
    }

    Object.keys(params.params).forEach(
      (key) => params.params[key] === undefined && delete params.params[key]
    )

    return requestResolver(
      api_gateway.get(`/api/v2/embeddedSim/simcard`, params)
    )
  },
  getProfiles: (
    pagina,
    linhasPorPagina,
    filtros = {},
    busca,
    separadorLinhaBusca,
    contagem
  ) => {
    const params = {
      params: {
        page: pagina,
        pageRows: linhasPorPagina,
        count: contagem,
        filter: filtros.vazio ? undefined : filtros,
        fetch: busca ? getParams(busca, separadorLinhaBusca) : undefined
      }
    }

    Object.keys(params.params).forEach(
      (key) => params.params[key] === undefined && delete params.params[key]
    )

    return requestResolver(
      api_gateway.get(`/api/v2/embeddedSim/fetchInventory`, params)
    )
  },
  getESimsFilter: () => {
    return requestResolver(
      api_gateway.get(`/api/v2/embeddedSim/fetchEmbeddedSimFilter`)
    )
  },
  getProfilesFilter: () => {
    return requestResolver(
      api_gateway.get(`/api/v2/embeddedSim/fetchInventoryFilters`)
    )
  },
  getProfilesInfo: (eidDevice) => {
    const statusOrder = {
      Ativo: 1,
      Inativo: 2,
      Removido: 3
    }

    const baseProfiles = [
      {
        profileName: 'Perfil 1',
        offerName: 'Oferta 1',
        profileStatusDescription: 'Ativo',
        carrierName: 'Vivo',
        updatedAt: '2025-09-10T14:23:00Z'
      },
      {
        profileName: 'Perfil 2',
        offerName: 'Oferta 2',
        profileStatusDescription: 'Inativo',
        carrierName: 'Claro',
        updatedAt: '2025-08-25T09:15:00Z'
      },
      {
        profileName: 'Perfil 3',
        offerName: 'Oferta 3',
        profileStatusDescription: 'Removido',
        carrierName: 'TIM',
        updatedAt: '2025-09-01T19:40:00Z'
      }
    ]

    let profiles = [...baseProfiles]

    if (eidDevice > 1) {
      const extraProfiles = Array.from({ length: 7 }, (_, i) => ({
        profileName: `Perfil ${i + 4}`, // Perfil 4,5,6...
        offerName: `Oferta ${i + 4}`, // Oferta 4,5,6...
        profileStatusDescription: i < 3 ? 'Inativo' : 'Removido',
        carrierName: 'TIM',
        updatedAt: new Date().toISOString()
      }))

      profiles = [...baseProfiles, ...extraProfiles].sort(
        (a, b) =>
          statusOrder[a.profileStatusDescription] -
          statusOrder[b.profileStatusDescription]
      )
    }

    return {
      profiles,
      item_count: profiles.length,
      pageRows: 10,
      page: 1,
      maxPage: 1
    }
    // return requestResolver(api_gateway.get(`/api/v2/embeddedSim/${eidDevice}/info`));
  }

  // getFiltersForActions: (method) => {
  //   //! method: switch or download
  //   return requestResolver(
  //     api_gateway.get(`/api/v2/embeddedSim/fetchEmbeddedSimFilterForActions`, {
  //       params: {
  //         method: method
  //       }
  //     })
  //   )
  // },
  // getSolicitations: () => {},
  // postSwitchOffer: (body) => {
  //   return requestResolver(
  //     api_gateway.post(`/api/v2/embeddedSim/switchOffer`, body)
  //   )
  // },
  // postDownloadProfile: (body) => {
  //   return requestResolver(
  //     api_gateway.post(`/api/v2/embeddedSim/downloadProfile`, body)
  //   )
  // }
  //#endregion GET
}
